import { createFileRoute } from "@tanstack/react-router";
import DeDealers from "@/pages/dealeri/DeDealers";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dealers/")({
  head: () => routeHead("/de/dealers/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DeDealers />
  );
}
